import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { AdminProductStatus } from '../enums/admin-product-status';

@Injectable({
  providedIn: 'root',
})
export class AdminProductStatusProviderService {
  private readonly entries = new Map<AdminProductStatus, string>([
    [AdminProductStatus.Draft, 'Szkic'],
    [AdminProductStatus.Private, 'Prywatny'],
    [AdminProductStatus.Protected, 'Chroniony hasłem'],
    [AdminProductStatus.Public, 'Publiczny'],
  ]);

  public labelFor(status: AdminProductStatus): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" code is not found.`,
      );
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<AdminProductStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) => new SelectItem(label, status),
      ),
    );
  }
}
